import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

function showUpdatePopup(registration) {
  const wantsUpdate = window.confirm(
    "A new version of this app is available. Press OK to update now."
  );

  if (wantsUpdate && registration.waiting) {
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
  }
}

if ("serviceWorker" in navigator) {
  // Set up message listener BEFORE registration
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "NEW_VERSION_READY") {
      window.location.reload();
    }
  });

  // Reload when new service worker takes control
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/serviceWorker.js")
      .then((registration) => {
        console.log("[App] Service Worker registered");

        // Check for updates on page load
        registration.update();

        // Check for waiting service worker on initial load
        if (registration.waiting) {
          showUpdatePopup(registration);
        }

        // Listen for new service worker installing
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              // New service worker installed, but old one still controlling
              showUpdatePopup(registration);
            }
          });
        });

        // Periodically check for updates (every 60 seconds)
        setInterval(() => {
          registration.update();
        }, 60000);
      })
      .catch((error) => {
        console.error("[App] Service Worker registration failed:", error);
      });
  });
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
